import { FunctionComponent } from "react";
import StackComponent from "../../../../components/stack";
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';

interface BatizadoStackProps {
  objectWithValues: any[]
}

const BatismoStack: FunctionComponent<BatizadoStackProps> = ({ objectWithValues }) => {
  const membrosHoje = objectWithValues?.filter((el) => {
    const fmtDat = new Date(el?.inscricao)?.toLocaleString('pt-BR')?.split(',')[0]?.replaceAll('/', '-');
    const hoje = new Date(Date.now())?.toLocaleString('pt-BR')?.split(',')[0]?.replaceAll('/', '-');
    return fmtDat?.match(hoje) && el?.batizado == 'Sim'
  })

  return (<>
    <StackComponent
      icon={<CalendarMonthRoundedIcon/>}
      title="Batizados"
      total={`${objectWithValues?.filter(el => el?.batizado == 'Sim').length}`}
      valueActual={`Novos ${membrosHoje?.length}`}
    />
  </>);
}

export default BatismoStack;
